import enFlag from "@icons/flags/ic-gb-rounded.svg";
import frFlag from "@icons/flags/ic-fr-rounded.png";
import plFlag from "@icons/flags/ic-pl-rounded.png";
import chFlag from "@icons/flags/ic-ch-rounded.png";
import deFlag from "@icons/flags/ic-de-rounded.png";
import swFlag from "@icons/flags/ic-sw-rounded.svg";

export const languageFlagPathArray = {
  1: enFlag,
  2: frFlag,
  3: plFlag,
  8: chFlag,
  6: deFlag,
  10: swFlag,
};

export const jobSiteKOColors = {
  0: "",
  1: "orange",
  2: "light-blue",
  3: "green",
};

export const quoteKOColors = {
  0: "#FF5200",
  1: "#FF9664",
  2: "#00AEEA",
  3: "#0A6800",
};

export const jobSiteKOStatuses = [
  "JOBSITE_KICK_OFF_STATUS_INITIAL",
  "JOBSITE_KICK_OFF_STATUS_VALIDATION",
  "JOBSITE_KICK_OFF_STATUS_IN_PROGRESS",
  "JOBSITE_KICK_OFF_STATUS_COMPLETE",
];

export const quoteKOStatuses = [
  "QUOTE_KICK_OFF_STATUS_PO_VALIDATION",
  "QUOTE_KICK_OFF_STATUS_SOLUTIONS_VALIDATION",
  "QUOTE_KICK_OFF_STATUS_OPERATION_ACCEPTANCE",
  "JOBSITE_KICK_OFF_STATUS_COMPLETE",
];

export const docsType = [
  {
    type: 23,
    title: "SITE_PROTOCOL_DOCUMENT",
  },
  {
    type: 1,
    title: "CHEMICAL_ANALYSIS",
  },
  {
    type: 2,
    title: "ANALYSE_GTR",
  },
  {
    type: 4,
    title: "SPECIFICATIONS",
  },
  {
    type: 3,
    title: "OTHER_DOCUMENT",
  },
  {
    type: 7,
    title: "TYPE_DOCUMENT_FOR_PARTNERS",
  },
  {
    type: 6,
    title: "POLLUTION_PARAM_DOC",
  },
  {
    type: 21,
    title: "CLIENT_CONSULTATION_DOCUMENT",
  },
];

export const enquiryTypeOptions = (t) => {
  return [
    { label: t("ENQUIRY_STATUS_TO_PROCESS"), value: 1 },
    { label: t("ENQUIRY_STATUS_QUOTATION"), value: 2 },
    { label: t("ENQUIRY_STATUS_DELETED"), value: 4 },
    { label: t("ENQUIRY_STATUS_CANCELED"), value: 6 },
    { label: t("ENQUIRY_STATUS_QUOTED"), value: 5 },
    { label: t("ENQUIRY_STATUS_REQUOTATION"), value: 9 },
  ];
};

export const quoteTypeOptions = (t) => {
  return [
    { label: t("QUOTE_STATUS_DRAFT"), value: 1 },
    { label: t("QUOTE_STATUS_SENT_CLIENT"), value: 2 },
    { label: t("QUOTE_STATUS_VALIDATED"), value: 3 },
    { label: t("QUOTE_STATUS_CANCELED"), value: 5 },
    { label: t("QUOTE_STATUS_LOST_CLIENT"), value: 6 },
    { label: t("QUOTE_STATUS_LOST_HESUS"), value: 7 },
  ];
};

export const quoteStatusText = {
  1: "QUOTE_STATUS_DRAFT",
  2: "QUOTE_STATUS_SENT_CLIENT",
  3: "QUOTE_STATUS_VALIDATED",
  5: "QUOTE_STATUS_CANCELED",
  6: "QUOTE_STATUS_LOST_CLIENT",
  7: "QUOTE_STATUS_LOST_HESUS",
};
export const quoteStatusColor = {
  1: "#FF981E",
  2: "#3EBBB9",
  3: "#008395",
  5: "#CCCCCC",
  6: "#E83F1E",
  7: "#E83F1E",
};

export const invoiceStatusText = {
  0: "CLIENT_INVOICING_STATUS_DRAFT",
  1: "CLIENT_INVOICING_STATUS_PREVALIDATED",
  2: "CLIENT_INVOICING_STATUS_VALIDATED",
  3: "CLIENT_INVOICING_STATUS_SENT",
  4: "CLIENT_INVOICING_STATUS_PAID",
  5: "CLIENT_INVOICING_STATUS_PARTIALLY_PAID",
  6: "CLIENT_INVOICING_STATUS_USED",
  7: "CLIENT_INVOICING_STATUS_PARTIALLY_USED",
  8: "CLIENT_INVOICING_STATUS_DISPUTE",
  9: "CLIENT_INVOICING_STATUS_CANCELED",
  10: "CLIENT_INVOICING_STATUS_PROFORMA",
};

export const invoiceStatusOptions = (t) => {
  return [
    { label: t("CLIENT_INVOICING_STATUS_ANY"), value: "" },
    {
      label: t("CLIENT_INVOICING_STATUS_DRAFT"),
      value: 0,
      bgColor: "#FF9800",
      color: "#fff",
    },
    {
      label: t("CLIENT_INVOICING_STATUS_PREVALIDATED"),
      value: 1,
      bgColor: "#9CD9C1",
      color: "#fff",
    },
    {
      label: t("CLIENT_INVOICING_STATUS_VALIDATED"),
      value: 2,
      bgColor: "#3EBBB9",
      color: "#fff",
    },
    {
      label: t("CLIENT_INVOICING_STATUS_SENT"),
      value: 3,
      bgColor: "#008395",
      color: "#fff",
    },
    {
      label: t("CLIENT_INVOICING_STATUS_PAID"),
      value: 4,
      bgColor: "#1F8813",
      color: "#fff",
    },
    {
      label: t("CLIENT_INVOICING_STATUS_PARTIALLY_PAID"),
      value: 5,
      bgColor: "#7AC943",
      color: "#fff",
    },
    {
      label: t("CLIENT_INVOICING_STATUS_USED"),
      value: 6,
      bgColor: "#32A728",
      color: "#fff",
    },
    {
      label: t("CLIENT_INVOICING_STATUS_PARTIALLY_USED"),
      value: 7,
      bgColor: "#7AC943",
      color: "#fff",
    },
    {
      label: t("CLIENT_INVOICING_STATUS_DISPUTE"),
      value: 8,
      bgColor: "#E83F1E",
      color: "#fff",
    },
    {
      label: t("CLIENT_INVOICING_STATUS_CANCELED"),
      value: 9,
      bgColor: "#767676",
      color: "#fff",
    },
    {
      label: t("CLIENT_INVOICING_STATUS_PROFORMA"),
      value: 10,
      bgColor: "#1BACE4",
      color: "#fff",
    },
  ];
};


export const invoiceWarning = (t) => {
  return {
    10: {
      title: t("CLIENT_INVOICING_DOCUMENT_UPDATE_TITLE"),
      message: t("CLIENT_INVOICING_SET_PROFORMA_POPUP_MESSAGE"),
    },
    3: {
      title: t("CLIENT_INVOICING_DOCUMENT_UPDATE_TITLE"),
      message: t("CLIENT_INVOICING_SET_SENT_POPUP_MESSAGE"),
    },
    4: {
      title: t("CLIENT_INVOICING_DOCUMENT_UPDATE_TITLE"),
      message: t("CLIENT_INVOICING_SET_PAID_POPUP_MESSAGE"),
    },
    6: {
      title: t("CLIENT_INVOICING_DOCUMENT_UPDATE_TITLE"),
      message: t("CLIENT_INVOICING_SET_USED_POPUP_MESSAGE"),
    },
    9: {
      title: t("CLIENT_INVOICING_DOCUMENT_UPDATE_TITLE"),
      message: t("CLIENT_INVOICING_SET_CANCELLED_POPUP_MESSAGE"),
    },
  };
};

export const invoiceStatusColor = {
  0: "#FF9800",
  1: "#9CD9C1",
  2: "#3EBBB9",
  3: "#008395",
  4: "#1F8813",
  5: "#7AC943",
  6: "#32A728",
  7: "#7AC943",
  8: "#E83F1E",
  9: "#767676",
  10: "#1BACE4",
};

export const invoiceStatusActionData = (
  t,
  status,
  documentType,
  documentSentByEmail
) => {
  const actions =  {
    0: [
      {
        label: t("CLIENT_INVOICING_SET_PROFORMA_ACTION"),
        value: 10,
      },
      {
        label: t("CLIENT_INVOICING_SET_CANCELLED_ACTION"),
        value: 9,
      },
    ],
    1: [
      {
        label: t("CLIENT_INVOICING_SET_CANCELLED_ACTION"),
        value: 9,
      },
    ],
    2: documentSentByEmail
      ? []
      : [
          {
            label: t("CLIENT_INVOICING_SET_SEND_ACTION"),
            value: 3,
          },
        ],
    3: documentType
      ? [
          {
            label: t("CLIENT_INVOICING_SET_PART_PAID_ACTION"),
            value: 5,
          },
          {
            label: t("CLIENT_INVOICING_SET_PAID_ACTION"),
            value: 4,
          },
          {
            label: t("CLIENT_INVOICING_SET_DISPUTE_ACTION"),
            value: 8,
          },
        ]
      : [
          {
            label: t("CLIENT_INVOICING_SET_PART_USED_ACTION"),
            value: 7,
          },
          {
            label: t("CLIENT_INVOICING_SET_USED_ACTION"),
            value: 6,
          },
        ],
    4: [
      {
        label: t("CLIENT_INVOICING_SET_SEND_ACTION"),
        value: 3,
      },
    ],
    5: [
      {
        label: t("CLIENT_INVOICING_SET_PAID_ACTION"),
        value: 4,
      },

      {
        label: t("CLIENT_INVOICING_SET_SEND_ACTION"),
        value: 3,
      },

      {
        label: t("CLIENT_INVOICING_SET_DISPUTE_ACTION"),
        value: 8,
      },
    ],
    6: [
      {
        label: t("CLIENT_INVOICING_SET_SEND_ACTION"),
        value: 3,
      },
    ],

    7: [
      {
        label: t("CLIENT_INVOICING_SET_USED_ACTION"),
        value: 6,
      },
      {
        label: t("CLIENT_INVOICING_SET_SEND_ACTION"),
        value: 3,
      },
    ],

    8: [
      {
        label: t("CLIENT_INVOICING_SET_PART_PAID_ACTION"),
        value: 5,
      },
      {
        label: t("CLIENT_INVOICING_SET_PAID_ACTION"),
        value: 4,
      },
    ],
  };
  return actions[status] || [];
};

export const solutionsListStatus = {
  ALL: 2,
  ACTIVE: 1,
  INACTIVE: 0,
};

export const solutionsActions = {
  DISABLE: "disable",
  SELECT: "select",
  VALIDATE: "validate",
  EDIT: "edit",
  ACTIVATE: "activate",
  INVALIDATE: "invalidate",
  DESELECT: "deselect",
  SOLUTION_VALIDATE: "solutionvalidate",
};

export const priceTypes = {
  TransportTreatmentSeparated: 1,
  TransportTreatment: 2,
  TransportOnly: 3,
  TreatmentOnly: 4,
};

export const country = {
  France: 2,
};

export const contactTypeText = {
  1: "CONTACT_TYPE_INVOICING",
  2: "CONTACT_TYPE_OPERATIONS",
  3: "CONTACT_TYPE_SALES",
  4: "CONTACT_TYPE_DECISION_MAKER",
  5: "CONTACT_TYPE_DISPATCH",
  6: "CONTACT_TYPE_PURCHASE_ORDER",
};

export const packagingTypeText = {
  1: "PACKAGING_TYPE_BULK",
  2: "PACKAGING_TYPE_BIGBAG",
  3: "PACKAGING_TYPE_BODYBENNE",
};

export const daysName = {
  MONDAY: "GENERAL_MONDAY",
  TUESDAY: "GENERAL_TUESDAY",
  WEDNESDAY: "GENERAL_WEDNESDAY",
  THURSDAY: "GENERAL_THURSDAY",
  FRIDAY: "GENERAL_FRIDAY",
  SATURDAY: "GENERAL_SATURDAY",
  SUNDAY: "GENERAL_SUNDAY",
};

export const enquiryDocumentTypes = [
  { id: "1", label: "TYPE_CHEMICAL_ANALYSIS" },
  { id: "2", label: "TYPE_OTHER_ANALYSIS" },
  { id: "3", label: "TYPE_OTHER" },
  { id: "6", label: "TYPE_POLLUTION_PARAMETERS" },
  { id: "11", label: "TYPE_SUPPLIER_QUOTE" },
  { id: "21", label: "TYPE_CLIENT_CONSULTATION" },
];

export const siteDocumentTypes = [
  { id: "1", label: "TYPE_CHEMICAL_ANALYSIS" },
  { id: "2", label: "TYPE_OTHER_ANALYSIS" },
  { id: "3", label: "TYPE_OTHER" },
  { id: "4", label: "TYPE_ENQUIRY_SPECIFICATIONS" },
];

export const kickOffDocumentTypes = [
  { id: "1", label: "TYPE_CHEMICAL_ANALYSIS" },
  { id: "2", label: "TYPE_OTHER_ANALYSIS" },
  { id: "3", label: "TYPE_OTHER" },
  { id: "4", label: "TYPE_ENQUIRY_SPECIFICATIONS" },
  { id: "21", label: "TYPE_CLIENT_CONSULTATION" },
  { id: "23", label: "TYPE_SITE_PROTOCOL" },
];

export const calculationCodeTypes = [
  { value: "DAYS", label: "DAYS" },
  { value: "DAYS_END_OF_MONTH", label: "DAYS_END_OF_MONTH" },
  { value: "DAYS_INVOICE_DATE", label: "DAYS_INVOICE_DATE" },
  { value: "DAYS_FROM_INVOICE_RECEIPT", label: "DAYS_FROM_INVOICE_RECEIPT" },
  { value: "ADVANCED", label: "ADVANCED" },
];

export const documentTypeColor = {
  1: "#0A4986",
  2: "#E83F1E",
  3: "#00AEEA",
  4: "#32A728",
  5: "#F2A1E0",
  6: "#3393F0",
  7: "#767676",
  8: "#32A728",
  9: "#6ACFCB",
  10: "#32A728",
  11: "#FF981E",
  12: "#32A728",
  13: "#EFCA06",
  14: "#F08046",
  15: "#AB6EFB",
  17: "#008395",
  18: "#3EBBB9",
  21: "#712DC9",
  22: "#B9F311",
  23: "#42098C",
};

export const documentName = {
  1: "TYPE_CHEMICAL_ANALYSIS",
  2: "TYPE_OTHER_ANALYSIS",
  3: "TYPE_OTHER",
  5: "TYPE_DISPUTE_PROOF",
  4: "TYPE_ENQUIRY_SPECIFICATIONS",
  6: "TYPE_POLLUTION_PARAMETERS",
  7: "TYPE_DOCUMENT_FOR_PARTNERS",
  8: "TYPE_SUMMARY_OTHER_SERVICE",
  9: "TYPE_MEETING_REPORT",
  10: "TYPE_SUMMARY_CENTRE_RECEIPT",
  11: "TYPE_SUPPLIER_QUOTE",
  12: "TYPE_SUMMARY_HAULAGE_TICKET",
  13: "TYPE_ANALYTICAL_NOTE",
  14: "TYPE_SITE_STATISTICS",
  15: "TYPE_HESUS_QUOTE",
  17: "TYPE_PRIOR_ACCEPTANCE",
  18: "TYPE_WASTE_TRACKING_SLIP",
  21: "TYPE_CLIENT_CONSULTATION",
  22: "TYPE_PURCHASE_ORDER",
  23: "TYPE_SITE_PROTOCOL",
};

// array on old status of quote
export const quoteMoreAction = {
  1: [{ id: "2", label: "QUOTE_ACTION_SEND_TO_CLIENT" }],
  2: [
    { id: "3", label: "QUOTE_ACTION_VALIDATE_CLIENT" },
    { id: "6", label: "QUOTE_STATUS_LOST_CLIENT" },
    { id: "7", label: "QUOTE_STATUS_LOST_HESUS" },
  ],
  3: [
    { id: "6", label: "QUOTE_STATUS_LOST_CLIENT" },
    { id: "7", label: "QUOTE_STATUS_LOST_HESUS" },
  ],
};

export const quoteMoreActionNoKickoff = {
  1: [
    { id: "2", label: "QUOTE_ACTION_SEND_TO_CLIENT" },
    { id: "3", label: "QUOTE_ACTION_VALIDATE_CLIENT" },
  ],
  2: [
    { id: "3", label: "QUOTE_ACTION_VALIDATE_CLIENT" },
    { id: "6", label: "QUOTE_STATUS_LOST_CLIENT" },
    { id: "7", label: "QUOTE_STATUS_LOST_HESUS" },
  ],
  3: [
    { id: "6", label: "QUOTE_STATUS_LOST_CLIENT" },
    { id: "7", label: "QUOTE_STATUS_LOST_HESUS" },
  ],
};

// array on old status of quote
export const quoteMoreActionPopUpText = {
  2: [
    { id: "7", label: "QUOTE_STATUS_LOST_HESUS" },
    { id: "6", label: "QUOTE_STATUS_LOST_CLIENT" },
  ],
  3: [
    { id: "7", label: "QUOTE_STATUS_LOST_HESUS" },
    { id: "6", label: "QUOTE_STATUS_LOST_CLIENT" },
  ],
};
// array on new status of quote then country id
export const quoteLostHesusReasons = {
  6: {
    1: [
      { value: "1", label: "Lost to the competition" },
      { value: "2", label: "Project cancelled" },
      { value: "3", label: "Lost for a pricing reason" },
      { value: "4", label: "Lost for political reason" },
      { value: "5", label: "Other" },
    ],
    2: [
      { value: "1", label: "Perdu face à la concurrence" },
      { value: "2", label: "Projet annulé" },
      { value: "3", label: "Perdue pour cause tarifaire" },
      { value: "4", label: "Perdue pour raison politique" },
      { value: "5", label: "Autre" },
    ],
    3: [
      { value: "1", label: "Strata na rzecz konkurencji" },
      { value: "2", label: "Projekt anulowany" },
      { value: "3", label: "Strata z powodu ceny" },
      { value: "4", label: "Strata z powodów politycznych" },
      { value: "5", label: "Inne" },
    ],
    6: [
      { value: "1", label: "Verloren an Wettbewerber" },
      { value: "2", label: "Projekt abgesagt" },
      { value: "3", label: "Verloren aus Kostengründen" },
      { value: "4", label: "Verloren aus politischen Gründen" },
      { value: "5", label: "Andere" },
    ],
    8: [
      { value: "1", label: "Perdu face à la concurrence" },
      { value: "2", label: "Projet annulé" },
      { value: "3", label: "Perdue pour cause tarifaire" },
      { value: "4", label: "Perdue pour raison politique" },
      { value: "5", label: "Autre" },
    ],
  },
  7: {
    1: [
      { value: "6", label: "Lost for a pricing reason" },
      { value: "7", label: "Lost for a financial reason" },
      { value: "8", label: "Lost despite agreement" },
      { value: "9", label: " Lost for political reason" },
      { value: "10", label: "Lost because wrong solution proposed" },
      { value: "11", label: "Lost for a reason of deadlines" },
      { value: "12", label: "Other" },
    ],
    2: [
      { value: "6", label: "Perdue pour cause tarifaire" },
      { value: "7", label: "Perdue pour cause financière" },
      { value: "8", label: "Perdue malgré bon pour accord" },
      { value: "9", label: "Perdue pour raison politique" },
      { value: "10", label: "Perdue car mauvaise solution proposée" },
      { value: "11", label: "Perdue pour cause de délai" },
      { value: "12", label: "Autre" },
    ],
    3: [
      { value: "6", label: "Strata z powodu ceny" },
      { value: "7", label: "Strata z powodów finansowych" },
      { value: "8", label: "Strata z powodu warunków umownych" },
      { value: "9", label: "Strata z powodów politycznych" },
      {
        value: "10",
        label: "Strata, ponieważ zaproponowano niewłaściwe rozwiązanie",
      },
      { value: "11", label: "Strata z powodu terminów wykonania" },
      { value: "12", label: "Inne" },
    ],
    6: [
      { value: "6", label: "Verloren aus Kostengründen" },
      { value: "7", label: "Verloren aus Finanzierungsgründen" },
      { value: "8", label: "Verloren trotz Übereinkunft" },
      { value: "9", label: "Verloren aus politischen Gründen" },
      { value: "10", label: "Verloren wegen falscher Lösungsansätze" },
      { value: "11", label: "Verloren wegen Deadline-Überschreitung" },
      { value: "12", label: "Verloren mangels Leistungsvermögen" },
    ],
    8: [
      { value: "6", label: "Perdue pour cause tarifaire" },
      { value: "7", label: "Perdue pour cause financière" },
      { value: "8", label: "Perdue malgré bon pour accord" },
      { value: "9", label: "Perdue pour raison politique" },
      { value: "10", label: "Perdue car mauvaise solution proposée" },
      { value: "11", label: "Perdue pour cause de délai" },
      { value: "12", label: "Autre" },
    ],
  },
};

export const disputeTypeText = {
  1: "DISPUTE_RESPONSIBILITY_CLIENT",
  2: "DISPUTE_RESPONSIBILITY_CENTRE",
  3: "DISPUTE_RESPONSIBILITY_HAULIER",
  4: "DISPUTE_RESPONSIBILITY_HESUS",
};
export const disputeTypeOption = (t) => [
  { label: t("DISPUTE_RESPONSIBILITY_CLIENT"), value: 1 },
  { label: t("DISPUTE_RESPONSIBILITY_CENTRE"), value: 2 },
  { label: t("DISPUTE_RESPONSIBILITY_HAULIER"), value: 3 },
  { label: t("DISPUTE_RESPONSIBILITY_HESUS"), value: 4 },
];

export const documentBasedEntityTypeOption = (t, type) => {
  if (type === "siteId") {
    return [
      { value: 1, label: t("TYPE_CHEMICAL_ANALYSIS") },
      { value: 2, label: t("TYPE_OTHER_ANALYSIS") },
      { value: 3, label: t("TYPE_OTHER") },
      { value: 4, label: t("TYPE_ENQUIRY_SPECIFICATIONS") },
      { value: 5, label: t("TYPE_DISPUTE_PROOF") },
      { value: 6, label: t("TYPE_POLLUTION_PARAMETERS") },
      { value: 8, label: t("TYPE_SUMMARY_OTHER_SERVICE") },
      { value: 9, label: t("TYPE_MEETING_REPORT") },
      { value: 10, label: t("TYPE_SUMMARY_CENTRE_RECEIPT") },
      { value: 11, label: t("TYPE_SUPPLIER_QUOTE") },
      { value: 12, label: t("TYPE_SUMMARY_HAULAGE_TICKET") },
      { value: 13, label: t("TYPE_ANALYTICAL_NOTE") },
      { value: 14, label: t("TYPE_SITE_STATISTICS") },
      { value: 15, label: t("TYPE_HESUS_QUOTE") },
      { value: 17, label: t("TYPE_PRIOR_ACCEPTANCE") },
      { value: 18, label: t("TYPE_WASTE_TRACKING_SLIP") },
      { value: 21, label: t("TYPE_CLIENT_CONSULTATION") },
      { value: 22, label: t("TYPE_PURCHASE_ORDER") },
      { value: 23, label: t("TYPE_SITE_PROTOCOL") },
    ];
  }
  if (type === "requestId") {
    return [
      { value: 1, label: t("TYPE_CHEMICAL_ANALYSIS") },
      { value: 2, label: t("TYPE_OTHER_ANALYSIS") },
      { value: 3, label: t("TYPE_OTHER") },
      { value: 6, label: t("TYPE_POLLUTION_PARAMETERS") },
      { value: 11, label: t("TYPE_SUPPLIER_QUOTE") },
      { value: 21, label: t("TYPE_CLIENT_CONSULTATION") },
    ];
  }
  if (type === "companyId") {
    return [
      { value: 3, label: t("TYPE_OTHER") },
      { value: 9, label: t("TYPE_MEETING_REPORT") },
      { value: 10, label: t("TYPE_SUMMARY_CENTRE_RECEIPT") },
      { value: 12, label: t("TYPE_SUMMARY_HAULAGE_TICKET") },
      { value: 17, label: t("TYPE_PRIOR_ACCEPTANCE") },
      { value: 18, label: t("TYPE_WASTE_TRACKING_SLIP") },
      { value: 22, label: t("TYPE_PURCHASE_ORDER") },
    ];
  }
  if (type === "") {
    return [
      { label: t("TYPE_OTHER"), value: 3 },
      { label: t("TYPE_PRIOR_ACCEPTANCE"), value: 17 },
      { label: t("TYPE_WASTE_TRACKING_SLIP"), value: 18 },
    ];
  }
};

export const SupplierPlanningLineUnit = ["TON", "M3", "LOAD"];
export const SolutionAcceptanceUnit = (t) => [
  { label: t("TON"), value: "TON" },
  { label: t("M3"), value: "M3" },
  { label: t("LOAD"), value: "LOAD" },
];
export const SupplierPlanningLineDefaultSelectedUnit = "LOAD";

export const PAGE_SIZE = 30;
export const KICKOFF_LIST_ENDPOINT = "/kickOff/fetch-records";
export const SOLUTIONS_LIST_ENDPOINT = "/solutions";
export const TABLE_JOBSITE = "jobsiteListTable";
export const TABLE_LEADS_LIST = "leadsList";
export const TABLE_SOLUTIONS_LIST = "solutionsList";
export const TABLE_COMPANY_SOLUTIONS_LIST = "companySolutionList";
export const TABLE_SELLING_PRICES_LIST = "sellingPricesList";
export const TABLE_KICKOFF_LIST = "koList";
export const TABLE_REQUEST_LIST_TO_BE_PROCESSED = "toBeProcessedRequestList";
export const TABLE_REQUEST_LIST_PENDING = "pendingRequestList";
export const FILTER_TYPE_DROPDOWN = "dropdown";
export const FILTER_TYPE_BUTTON = "button";
export const FILTER_TYPE_MULTI_SELECT_DROPDOWN = "multiSelectDropdown";
export const FILTER_TYPE_DATEPICKER = "filterDatePicker";
export const TABLE_QUOTES_LIST = "quotesList";
export const TABLE_USER_LIST = "usersList";
export const TABLE_MEETING_REPORTS_LIST = "meetingReportsList";
export const TABLE_MEETING_REPORTS_LIST_WITH_BUTTON =
  "meetingReportsListWithButton";
export const TABLE_TRANSPORT_QUOTATIONS = "transportQuotations";
export const TABLE_JOBSITE_SELLING_PRICES_LIST = "jobsiteSellingPriceList";
export const TABLE_ANALYTICAL_NOTES_LIST = "analyticalNotesList";
export const ANALYTICAL_NOTES_LIST_ENDPOINT = "/analyticalNotes";
export const MEETING_REPORTS_LIST_ENDPOINT = "/meetingReports";
export const TABLE_CONTACTS_LIST = "contactsList";
export const TABLE_CONTACTS_LIST_MAIN = "contactsListMain";
export const CONTACT_LIST_ENDPOINT = "/contacts";
export const TABLE_RELATED_CONTACTS_LIST = "relatedContactsList";
export const RELATED_CONTACT_LIST_ENDPOINT = "/relatedContacts";
export const TABLE_PRODUCTS_LIST = "productsList";
export const PRODUCTS_LIST_ENDPOINT = "/products";
export const TABLE_CENTER_PRODUCTS_LIST = "centerProductsList";
export const TABLE_CENTER_PRODUCT_PRICE_LIST = "centerProductPriceList";
export const CENTER_PRODUCTS_LIST_ENDPOINT =
  "/companies/{companyId}/centres/{centreId}/products";
export const CENTER_LIST_ENDPOINT = "/companies/{companyId}/centres";
export const CENTER_PRODUCT_PRICE_LIST_ENDPOINT =
  "/companies/{companyId}/centres/{centreId}/products/{centreProductId}/prices";
export const TABLE_COMPANY_LIST = "companyList";
export const TABLE_COMPANY_LIST_ENDPOINT = "/companies";
export const TABLE_CENTER_LIST = "centerList";
export const WAREHOUSE_LIST_ENDPOINT =
  "/companies/{companyId}/hauliers/{haulierId}/warehouses";
export const TABLE_SITES_LIST = "sitesList";
export const TABLE_ENQUIRY_LIST = "EnquiryList";
export const SITE_LIST_ENDPOINT = "/sites";
export const ENQUIRIES_LIST_ENDPOINT = "/enquiries";
export const TABLE_SELLING_PRICE_LIST = "sellingPriceList";
export const TABLE_SELLING_PRICE_LIST_ENDPOINT = "/v2/sellingPrices";
export const QUOTES_LIST_ENDPOINT = "/quotes";
export const TABLE_VAT_LIST = "vatList";
export const VAT_LIST_ENDPOINT = "/general/vatRates";
export const TABLE_BANK_ACCOUNT_LIST = "bankAccountList";
export const BANK_ACCOUNT_LIST_ENDPOINT = "/general/bankAccounts";
export const TABLE_PAYMENT_TERMS_LIST = "paymentTerms";
export const TABLE_PURCHASE_ORDER_LIST = "purchaseOrders";
export const PURCHASE_ORDER_LIST_ENDPOINT = "/purchaseOrders";
export const TABLE_SPECIFIC_CONDITIONS_LIST = "specificConditions";
export const TABLE_ADMIN_LIST = "admins";
export const SPECIFIC_CONDITIONS_LIST_ENDPOINT = "/general/specificConditions";
export const TABLE_TRANSLATION_LIST = "translationList";
export const TABLE_TRANSPORT_LIST = "transport";
export const TABLE_MENTION_GROUP_LIST = "mentiongroup";
export const TABLE_MAIL_TOKEN_LIST = "mailTokenList";
export const MAIL_TOKEN_LIST_ENDPOINT = "/general/mailTokens";
export const LEAD_LIST_ENDPOINT = "/leads";
export const TABLE_GENERAL_PARAMETERS_LIST = "generalParametersList";
export const GENERAL_PARAMETERS_LIST_ENDPOINT = "/general/countryParameters";
